import { DataTable } from "../../../../../shared";

const MarketingAttributionReportTable = ({
  testId,
  columns,
  data,
  totalRows,
  numberOfRowsPerPage,
  pageNumber,
  sortedBy,
  onPageChange,
  onColumnSort,
}) => {
  return (
    <div
      data-testid={testId}
      className="mt-3 bg-white shadow rounded pt-3"
    >
      <DataTable
        columns={columns}
        data={data}
        totalRows={totalRows}
        numberOfRowsPerPage={numberOfRowsPerPage}
        pageNumber={pageNumber}
        sortedBy={sortedBy}
        onPageChange={onPageChange}
        onColumnSort={onColumnSort}
      />
    </div>
  );
};

export default MarketingAttributionReportTable;
